(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const installed = Symbol.for('greenleaf.aiod.cart-renderer');
  const hook = 'csappsShowCartDiscounts';
  const descriptor = Object.getOwnPropertyDescriptor(window, hook);
  if (window[installed] || (descriptor && !descriptor.configurable)) return;
  window[installed] = true;

  const properties = value => (Array.isArray(value) ? [...value] : Object.entries(value || {}))
    .filter(([key]) => !key.startsWith('_CSAIOD_'))
    .sort(([a], [b]) => a.localeCompare(b));
  const signature = items => JSON.stringify(items.map(item => [
    String(item.variant_id || item.id),
    Number(item.quantity),
    properties(item.properties),
    Number(item.selling_plan_id || item.selling_plan_allocation?.selling_plan?.id || 0)
  ]));
  const surfaces = () => [...document.querySelectorAll('[data-greenleaf-cart-surface]')].flatMap(root => {
    const snapshot = root.querySelector('[data-greenleaf-cart-lines]');
    if (!snapshot) return [];
    try {
      const items = JSON.parse(snapshot.textContent);
      if (!Array.isArray(items)) return [];
      return [{root, snapshot, items}];
    } catch {
      return [];
    }
  });
  const restoreNative = root => {
    root.querySelectorAll('[data-greenleaf-price]').forEach(price => {
      const row = price.closest('[data-csapp_line_index]');
      const template = row?.querySelector(`template[data-greenleaf-native-price="${price.dataset.greenleafPrice}"]`);
      if (template) price.replaceChildren(template.content.cloneNode(true));
    });
    const template = root.querySelector('template[data-greenleaf-native-subtotal]');
    const subtotal = root.querySelector('[data-greenleaf-subtotal]');
    if (template && subtotal) subtotal.replaceWith(template.content.cloneNode(true));
    root.querySelectorAll('[data-greenleaf-native-discount]').forEach(discount => {
      discount.hidden = false;
      discount.style.removeProperty('display');
    });
  };
  const showResponsePrices = (root, cart) => {
    const app = window.csapps;
    if (typeof app?.formatMoney !== 'function') return;
    const subtotal = Number(cart.items_subtotal_price);
    const responseTotal = cart.items.reduce((sum, item) => sum + Number(item.final_line_price), 0);
    const reconciledItems = cart.items.map(item => {
      if (app.settings?.discount?.setting?.apply_discount !== 'draft_order' ||
          !Array.isArray(item.line_level_discount_allocations) || item.line_level_discount_allocations.length) return item;
      return {...item, final_price: item.original_price, final_line_price: item.original_line_price};
    });
    const reconciledTotal = reconciledItems.reduce((sum, item) => sum + Number(item.final_line_price), 0);
    const items = responseTotal !== subtotal && reconciledTotal === subtotal ? reconciledItems : cart.items;
    const rows = [...root.querySelectorAll('[data-csapp_line_index]')];
    items.forEach((item, index) => {
      rows[index]?.querySelectorAll('[data-greenleaf-price]').forEach(price => {
        const isLine = price.dataset.greenleafPrice === 'line';
        const finalPrice = Number(isLine ? item.final_line_price : item.final_price);
        const originalPrice = Number(isLine ? item.original_line_price : item.original_price);
        if (!Number.isFinite(finalPrice) || !Number.isFinite(originalPrice)) return;
        const labels = [...price.querySelectorAll('.discount-label-conatiner')];
        const compare = originalPrice > finalPrice
          ? `<del class="money">${app.formatMoney(originalPrice, app.money_format)}</del>` : '';
        price.innerHTML = `<div class="${isLine ? 'csapp-line-price' : 'csapp-price'}">${compare}<span class="money${compare ? ' cs_final_price' : ''}">${app.formatMoney(finalPrice, app.money_format)}</span></div>`;
        labels.forEach(label => price.append(label));
      });
    });
    root.querySelectorAll('[data-greenleaf-native-discount]').forEach(discount => {
      discount.hidden = true;
      discount.style.display = 'none';
    });
  };

  let latest;
  let rendering = false;
  const render = request => {
    const {original, context, cart, args} = request;
    if (!Array.isArray(cart?.items)) return original.call(context, cart, ...args);
    const current = surfaces();
    if (!current.length) return original.call(context, cart, ...args);
    const expected = signature(cart.items);
    const matching = current.filter(surface => signature(surface.items) === expected &&
      (!cart.currency || cart.currency === surface.snapshot.dataset.currency));
    if (!matching.length) return;
    const stale = current.filter(surface => !matching.includes(surface));
    const retained = stale.flatMap(({root}) => [...root.querySelectorAll('[data-greenleaf-price], [data-greenleaf-subtotal]')]
      .map(element => ({element, html: element.innerHTML})));
    matching.forEach(({root}) => restoreNative(root));
    rendering = true;
    try {
      const result = original.call(context, cart, ...args);
      matching.forEach(({root, snapshot}) => {
        if (!snapshot.isConnected) return;
        if (Number(cart.total_discount) === 0) restoreNative(root);
        else if (Number(cart.total_discount) > 0) showResponsePrices(root, cart);
      });
      return result;
    } finally {
      retained.forEach(({element, html}) => { if (element.isConnected) element.innerHTML = html; });
      rendering = false;
    }
  };
  const wrapped = new WeakMap();
  const wrap = original => {
    if (typeof original !== 'function') return original;
    if (wrapped.has(original)) return wrapped.get(original);
    const handler = function(cart, ...args) {
      latest = {original, context: this, cart, args};
      return render(latest);
    };
    wrapped.set(original, handler);
    wrapped.set(handler, handler);
    return handler;
  };
  let handler = wrap(window[hook]);
  Object.defineProperty(window, hook, {
    configurable: true,
    enumerable: descriptor?.enumerable ?? true,
    get() { return handler; },
    set(value) { handler = wrap(value); }
  });

  // Refresh only the cart rows and totals after the theme updates its drawer.
  let pageRevision = 0;
  const refreshPage = async () => {
      const page = document.querySelector('[data-greenleaf-cart-surface="page"]');
      if (!page) return;
      const section = page.closest('[id^="shopify-section-"]');
      if (!section) return;
      const ticket = ++pageRevision;
      const url = new URL(page.action, window.location.href);
      url.searchParams.set('section_id', section.id.slice('shopify-section-'.length));
      try {
        const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw new Error('Cart section unavailable');
        const html = await response.text();
        if (ticket !== pageRevision || !page.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector('[data-greenleaf-cart-surface="page"]');
        const drawer = surfaces().find(surface => surface.root.dataset.greenleafCartSurface === 'drawer');
        if (!fresh) {
          const empty = parsed.querySelector('.cart--empty-cart');
          if (!empty || drawer) throw new Error('Cart section does not match the drawer');
          page.replaceWith(empty);
          return;
        }
        const snapshot = fresh.querySelector('[data-greenleaf-cart-lines]');
        const items = JSON.parse(snapshot.textContent);
        if (!drawer || signature(items) !== signature(drawer.items) ||
            snapshot.dataset.currency !== drawer.snapshot.dataset.currency) {
          throw new Error('Cart section does not match the drawer');
        }
        const table = fresh.querySelector('.cart-table');
        const totals = fresh.querySelector('[data-greenleaf-page-totals]');
        if (!table || !totals) throw new Error('Cart section is incomplete');
        // These are newly rendered buttons; the original section's handlers
        // belong to the discarded table. Keep the native quantity behaviour.
        table.addEventListener('click', event => {
          const button = event.target.closest('.js-qty__adjust');
          if (!button || !table.contains(button)) return;
          event.preventDefault();
          const input = button.closest('.js-qty').querySelector('input');
          const adjustment = button.classList.contains('js-qty__adjust--minus') ? -1 : 1;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + adjustment);
        });
        page.querySelector('.cart-table').replaceWith(table);
        page.querySelector('[data-greenleaf-page-totals]').replaceWith(totals);
        const eligibility = page.closest('.width--content');
        const freshEligibility = fresh.closest('.width--content');
        if (eligibility && freshEligibility) {
          eligibility.classList.toggle('box-now-widget', freshEligibility.classList.contains('box-now-widget'));
        }
        page.querySelector('[data-greenleaf-cart-refresh-error]')?.remove();
      } catch (error) {
        if (ticket !== pageRevision || !page.isConnected) return;
        let notice = page.querySelector('[data-greenleaf-cart-refresh-error]');
        if (!notice) {
          notice = document.createElement('p');
          notice.dataset.greenleafCartRefreshError = '';
          notice.setAttribute('role', 'status');
          const link = document.createElement('a');
          link.href = page.action;
          link.textContent = document.documentElement.lang.startsWith('el')
            ? 'Ανανέωσε το καλάθι για να δεις τις τελευταίες αλλαγές.'
            : 'Refresh your cart to see the latest changes.';
          notice.append(link);
          page.prepend(notice);
        }
        console.warn('Greenleaf cart page refresh failed:', error);
      }
  };

  const releaseClosedCartLock = () => {
    const drawers = [...document.querySelectorAll('cart-drawer')];
    if (!drawers.length || drawers.some(drawer => drawer.getAttribute('aria-hidden') !== 'true')) return;
    const boostCart = document.querySelector('#boost-sd__modal-cart');
    if (boostCart && getComputedStyle(boostCart).display !== 'none') return;
    if (document.body.classList.contains('modal-open-cart')) document.body.classList.remove('modal-open-cart');
  };
  const watchCartLifecycle = () => {
    const observer = new MutationObserver(releaseClosedCartLock);
    document.querySelectorAll('cart-drawer').forEach(drawer => {
      observer.observe(drawer, {attributes: true, attributeFilter: ['aria-hidden']});
    });
    observer.observe(document.body, {attributes: true, attributeFilter: ['class']});
    releaseClosedCartLock();
  };
  if (document.body) watchCartLifecycle();
  else document.addEventListener('DOMContentLoaded', watchCartLifecycle, {once: true});
  window.addEventListener('pageshow', event => {
    const fromHistory = event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    const cartVisible = document.querySelector('[data-greenleaf-cart-surface="page"], cart-drawer[aria-hidden="false"]');
    if (fromHistory && cartVisible) window.location.reload();
    else releaseClosedCartLock();
  });

  const observe = () => {
    let previous = surfaces().map(({snapshot}) => [snapshot, snapshot.textContent]);
    let previousDrawer = surfaces().find(({root}) => root.dataset.greenleafCartSurface === 'drawer')?.snapshot;
    let previousDrawerText = previousDrawer?.textContent;
    new MutationObserver(() => {
      if (rendering) return;
      const next = surfaces().map(({snapshot}) => [snapshot, snapshot.textContent]);
      const changed = next.length !== previous.length || next.some(([node, text], index) =>
        node !== previous[index]?.[0] || text !== previous[index]?.[1]);
      previous = next;
      const drawer = surfaces().find(({root}) => root.dataset.greenleafCartSurface === 'drawer')?.snapshot;
      const drawerChanged = drawer !== previousDrawer || drawer?.textContent !== previousDrawerText;
      previousDrawer = drawer;
      previousDrawerText = drawer?.textContent;
      if (drawerChanged && typeof refreshPage === 'function') refreshPage();
      if (changed && latest && next.length) render(latest);
    }).observe(document.body, {childList: true, subtree: true, characterData: true});
  };
  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe, {once: true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["greenleaf-boxnow-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('greenleaf-boxnow-card')) {
    customElements.define('greenleaf-boxnow-card', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.surface === 'page') {
          this.connectPage();
          return;
        }
        if (!this.closest('cart-drawer')) return;
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => this.presentWidget());
        this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
        this.presentWidget();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      connectPage() {
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => this.presentPage());
        this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
        this.presentPage();
      }
      presentPage() {
        const button = this.querySelector('.tp-boxnow-map-widget-button');
        this.hidden = !button;
        if (!button) return;
        const details = this.querySelector('.tp-box-now-locker-selection__details');
        const id = this.querySelector('#tp-box-now-selected-locker-id')?.textContent.trim();
        const name = this.querySelector('#tp-box-now-selected-locker-name')?.textContent.trim();
        const selected = details && !details.classList.contains('tp-hidden') && !!id;
        const label = selected ? this.dataset.changeLabel : this.dataset.selectLabel;
        if (button.textContent !== label) button.textContent = label;
        button.type = 'button';
        const remove = this.querySelector('.tp-box-now-locker-selection__details-unselect-btn');
        if (remove) {
          remove.type = 'button';
          if (remove.textContent !== this.dataset.removeLabel) remove.textContent = this.dataset.removeLabel;
        }
        const heading = details?.querySelector(':scope > p:first-child');
        if (heading && heading.textContent !== this.dataset.selectedLabel) heading.textContent = this.dataset.selectedLabel;
        for (const [selector, text] of [
          ['#tp-box-now-selected-locker-id', this.dataset.idLabel],
          ['#tp-box-now-selected-locker-name', this.dataset.nameLabel]
        ]) {
          const fieldLabel = this.querySelector(selector)?.previousElementSibling;
          if (fieldLabel && fieldLabel.textContent !== text) fieldLabel.textContent = text;
        }
        const map = this.querySelector('.tp-box-now-locker-map-container');
        const iframe = map?.querySelector('iframe');
        if (map) {
          let close = this.querySelector('.gl-boxnow__map-close');
          if (!close) {
            close = document.createElement('button');
            close.type = 'button';
            close.className = 'gl-boxnow__map-close';
            close.textContent = this.dataset.closeMapLabel;
            close.addEventListener('click', () => {
              map.hidden = true;
              close.hidden = true;
              button.focus();
            });
            map.after(close);
          }
          if (this.mapFrame !== iframe) {
            this.mapFrame = iframe;
            map.hidden = !iframe;
            close.hidden = !iframe;
          } else if (!iframe) {
            map.hidden = true;
            close.hidden = true;
          }
        }
        const signature = selected ? id + '|' + name : '';
        if (this.selectionSignature === signature) return;
        this.selectionSignature = signature;
        const addressRequest = {};
        this.addressRequest = addressRequest;
        this.querySelector('[data-boxnow-address]')?.remove();
        if (!selected) return;
        fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store' })
          .then(response => response.ok ? response.json() : null)
          .then(cart => {
            if (!this.isConnected || this.addressRequest !== addressRequest || this.selectionSignature !== signature) return;
            const attributes = cart?.attributes;
            if (String(attributes?.boxnow_locker_id) !== id || !attributes?.boxnow_locker_address) return;
            const address = document.createElement('p');
            address.dataset.boxnowAddress = '';
            const label = document.createElement('span');
            label.className = 'tp-box-now-locker-selection__details-label';
            label.textContent = this.dataset.addressLabel + ' ';
            address.append(label, document.createTextNode(attributes.boxnow_locker_address));
            details.insertBefore(address, remove);
          })
          .catch(() => {});
      }
      presentWidget() {
        const button = this.querySelector('#tp-box-now-drawer-lockers-button');
        this.hidden = !button;
        if (!button) return;
        const name = this.querySelector('.tp-drawer-locker-name-text');
        const label = name?.textContent.trim() ? this.dataset.changeLabel : this.dataset.selectLabel;
        if (button.textContent !== label) button.textContent = label;
        if (button.type !== 'button') button.type = 'button';
        const selectedLabel = this.querySelector('.tp-drawer-locker-name-wrapper > span:first-child');
        if (selectedLabel && selectedLabel.textContent !== this.dataset.selectedLabel) selectedLabel.textContent = this.dataset.selectedLabel;
        const remove = this.querySelector('.tp-drawer-locker-remove-button');
        if (remove && remove.textContent !== this.dataset.removeLabel) remove.textContent = this.dataset.removeLabel;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["greenleaf-catalog-menu"] && !Shopify.designMode) return;
  try {
    function updatePotPreview(event) {
  const link = event.target.closest('.gl-catalog-menu--pots .gl-catalog-menu__primary a');
  if (!link) return;
  const menu = link.closest('.gl-catalog-menu--pots');
  const destination = href => {
    const url = new URL(href);
    return decodeURIComponent(url.pathname) + (menu.classList.contains('gl-catalog-menu--hydroculture') ? '?' + new URLSearchParams(url.search).toString() : '');
  };
  const path = destination(link.href);
  const cards = menu.querySelectorAll('.gl-pots-preview__card');
  const selected = Array.from(cards).find(card => destination(card.href) === path);
  if (!selected) return;
  cards.forEach(card => {
    const active = card === selected;
    card.classList.toggle('is-active', active);
    card.setAttribute('aria-hidden', String(!active));
    card.tabIndex = active ? 0 : -1;
  });
  menu.querySelectorAll('.gl-catalog-menu__primary a, .gl-catalog-menu__group a').forEach(item => item.classList.toggle('is-previewed', item === link));
}
document.addEventListener('pointerover', updatePotPreview);
document.addEventListener('focusin', updatePotPreview);
  } catch(e) { console.error(e); }
})();

})();
